module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lacerta/lac_oc-0926ac3b6f68d588c0b13d622d8b7fac.gif";